import React, { ReactNode } from 'react';
import { checkBrowserVersion } from '../utils/browser-check';
import { UnsupportedBrowserPage } from '../pages/UnsupportedBrowserPage';

interface Props {
  children: ReactNode;
}

export const BrowserGuard: React.FC<Props> = ({ children }) => {
  const browserCheck = checkBrowserVersion();

  if (!browserCheck.supported) {
    return <UnsupportedBrowserPage browserInfo={browserCheck} />;
  }

  return <>{children}</>;
};
